<ng-container>
	<div>
		<h3>User Identification</h3>
		<p>
			Please take <strong>{{numberOfPictures}} clear picture(s)</strong> of your business premises to verify
			your
			business. (Please use a mobile
			phone for more accurate results)
		</p>
		<div>
			<webcam 
				*ngIf="showWebcam && snapShots.length === 0" 
				[height]="500" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
				[allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
				[videoOptions]="videoOptions" [imageQuality]="0.8" (cameraSwitched)="cameraWasSwitched($event)"
				(initError)="handleInitError($event)">
			</webcam>

			<div class="camera-shutter" *ngIf="snapShots.length < numberOfPictures">
				<svg (click)="triggerSnapshot();" fill="none" height="40" viewBox="0 0 41 40" width="41"
					xmlns="http://www.w3.org/2000/svg">
					<circle cx="20.4998" cy="19.9998" fill="#0361F0" r="16.8182" />
					<circle cx="20.5" cy="20" r="19.1307" stroke="#0361F0" stroke-width="1.26136" />
					<path clip-rule="evenodd"
						d="M15.5463 15.0754C15.0758 15.0754 14.6246 15.2652 14.292 15.6032C13.9593 15.9411 13.7725 16.3994 13.7725 16.8773V24.0851C13.7725 24.563 13.9593 25.0214 14.292 25.3593C14.6246 25.6972 15.0758 25.8871 15.5463 25.8871H26.189C26.6594 25.8871 27.1106 25.6972 27.4433 25.3593C27.7759 25.0214 27.9628 24.563 27.9628 24.0851V16.8773C27.9628 16.3994 27.7759 15.9411 27.4433 15.6032C27.1106 15.2652 26.6594 15.0754 26.189 15.0754H24.7824C24.5472 15.0753 24.3216 14.9804 24.1554 14.8114L23.1611 13.8014C22.8286 13.4635 22.3775 13.2735 21.9071 13.2734H19.8282C19.3578 13.2735 18.9067 13.4635 18.5741 13.8014L17.5799 14.8114C17.4136 14.9804 17.1881 15.0753 16.9529 15.0754H15.5463ZM20.8676 23.1842C21.217 23.1842 21.563 23.1142 21.8858 22.9784C22.2086 22.8426 22.502 22.6435 22.749 22.3925C22.9961 22.1415 23.1921 21.8435 23.3258 21.5156C23.4595 21.1877 23.5283 20.8362 23.5283 20.4812C23.5283 20.1263 23.4595 19.7748 23.3258 19.4469C23.1921 19.1189 22.9961 18.821 22.749 18.57C22.502 18.319 22.2086 18.1199 21.8858 17.9841C21.563 17.8482 21.217 17.7783 20.8676 17.7783C20.162 17.7783 19.4852 18.0631 18.9862 18.57C18.4873 19.0769 18.2069 19.7644 18.2069 20.4812C18.2069 21.1981 18.4873 21.8856 18.9862 22.3925C19.4852 22.8994 20.162 23.1842 20.8676 23.1842Z"
						fill="white" fill-rule="evenodd" />
				</svg>
			</div>
		</div>
	</div>

	<div *ngIf="snapShots.length > 0" nz-col nzSpan="24">
		<div class="m-t-20">
			<div *ngFor="let snapShot of snapShots; let index = index">
				<div class="photo-box">
					<ng-container *ngIf="snapShot">
						<img class="block w-full" [src]="snapShot.imageAsDataUrl" alt="" />
						<i nz-icon nzType="close-circle" class="close" nzTheme="fill"
							(click)="removePhoto(snapShot)"></i>
					</ng-container>
				</div>
			</div>
		</div>
	</div>

	<h4 *ngIf="errors.length > 0">Messages:</h4>

	<ul *ngFor="let error of errors">
		<li>{{error | json}}</li>
	</ul>

	<div class="mt-2.5" *ngIf="errorMessage">
		<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
	</div>

	<div>
		<div nz-col nzSpan="24">
			<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="mt-5">
				<div nz-col class="gutter-row" [nzSpan]="12">
					<button class="btn btn-secondary btn-block"
						(click)="cancel.emit()">{{'moniepoint.cancel'|translate}}</button>
				</div>

				<div nz-col class="gutter-row" [nzSpan]="12">
					<app-custom-submit-button [disabled]="snapShots.length < numberOfPictures" [block]="true"
						[submitting]="loading" name="{{'moniepoint.save_changes'|translate}}" (submitForm)="submit()">
					</app-custom-submit-button>
				</div>
			</div>
		</div>
	</div>
</ng-container>